import React from 'react';
import PropTypes from 'prop-types';
import findByString from "../../../../../../../../../Utils/Form/FormDynamic/Utils/getValueByString";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup/ToggleButtonGroup";
import ToggleButton from "@material-ui/lab/ToggleButton";
import {makeStyles, Tooltip} from "@material-ui/core";
import {
    FormatAlignCenter,
    FormatAlignLeft, FormatAlignRight, FormatLineSpacing,
    VerticalAlignBottom,
    VerticalAlignCenter,
    VerticalAlignTop
} from "@material-ui/icons";
import FormatAlignJustify from "@material-ui/icons/FormatAlignJustify";

const useStyles = makeStyles(() => ({
    buttonGroupIcon: {
        height: 27,
        padding: 0,
        borderRadius: 0,
        border: "1px solid !important",
        margin: "0 5px",
        borderColor: "#cbcbcb !important"
    },
}));

const AlignmentBlock = ({label, path, setValue, values, type}) => {
    const value = findByString(values, path);
    function onChange(e, v) {
        v && setValue(v, path)
    }
    return (
        <div style={{display: 'flex', marginTop: 5, alignItems: 'center'}}>
            <div style={{width: 102}}>
                {label}
            </div>
            {type === 'horizontal' ? (
                <HorizontalGroup
                    onChange={onChange}
                    value={value}
                />
            ) : (
                <VerticalGroup
                    onChange={onChange}
                    value={value}
                />
            )}
        </div>
    );
};

AlignmentBlock.propTypes = {
    label: PropTypes.string,
    path: PropTypes.string,
    setValue: PropTypes.func,
    values: PropTypes.object,
    type: PropTypes.oneOf(['horizontal', 'vertical'])
};

export default AlignmentBlock;

const HorizontalGroup = ({value, onChange}) => {
    const classes = useStyles();
    return (
        <ToggleButtonGroup
            value={value}
            exclusive
            onChange={onChange}
            aria-label="content alignment">
            <ToggleButton size={"small"} value="flex-start" aria-label="flex-start"
                          className={classes.buttonGroupIcon}
            >
                <Tooltip title={'Left'}>
                    <FormatAlignLeft/>
                </Tooltip>
            </ToggleButton>
            <ToggleButton size={"small"} value="center" aria-label="center"
                          className={classes.buttonGroupIcon}
            >
                <Tooltip title={'Center'}>
                    <FormatAlignCenter/>
                </Tooltip>
            </ToggleButton>
            <ToggleButton size={"small"} value="flex-end" aria-label="flex-end"
                          className={classes.buttonGroupIcon}
            >
                <Tooltip title={'Right'}>
                    <FormatAlignRight/>
                </Tooltip>
            </ToggleButton>
            <ToggleButton size={"small"} value="space-between" aria-label="space-between"
                          className={classes.buttonGroupIcon}
            >
                <Tooltip title={'Space Between'}>
                    <FormatAlignJustify/>
                </Tooltip>
            </ToggleButton>
        </ToggleButtonGroup>
    )
}

const VerticalGroup = ({value, onChange}) => {
    const classes = useStyles();
    return (
        <ToggleButtonGroup
            value={value}
            exclusive
            onChange={onChange}
            aria-label="content alignment">
            <ToggleButton size={"small"} value="flex-start" aria-label="flex-start"
                          className={classes.buttonGroupIcon}>
                <Tooltip title={'Top'}>
                    <VerticalAlignTop/>
                </Tooltip>
            </ToggleButton>
            <ToggleButton size={"small"} value="center" aria-label="center"
                          className={classes.buttonGroupIcon}>
                <Tooltip title={'Center'}>
                    <VerticalAlignCenter/>
                </Tooltip>
            </ToggleButton>
            <ToggleButton size={"small"} value="flex-end" aria-label="flex-end"
                          className={classes.buttonGroupIcon}>
                <Tooltip title={'Bottom'}>
                    <VerticalAlignBottom/>
                </Tooltip>
            </ToggleButton>
            <ToggleButton size={"small"} value="stretch" aria-label="flex-end"
                          className={classes.buttonGroupIcon}>
                <Tooltip title={'Stretch'}>
                    <FormatLineSpacing/>
                </Tooltip>
            </ToggleButton>
        </ToggleButtonGroup>
    )
}